<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="visibleSidebar"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Restablecer contraseña"
  [style]="{ width: '400px' }"
  (onHide)="onClose()"
  [closable]="false"
  [closeOnEscape]="false"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12">
            <label>Introduzca su nueva contraseña</label>
            <div>
              <p-password
                formControlName="password"
                [toggleMask]="true"
              ></p-password>
              <div
                *ngIf="
                  fg.get('password').invalid &&
                  (fg.get('password').dirty || fg.get('password').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('password').errors?.required">
                  <small class="p-error">No puede quedar vacío.</small>
                </div>
                <div *ngIf="fg.get('password').errors?.minlength">
                  <small class="p-error"
                    >Debe tener una longitud mínima de 5.</small
                  >
                </div>
                <div *ngIf="fg.get('password').errors?.maxlength">
                  <small class="p-error"
                    >Debe tener una longitud máxima de 255.</small
                  >
                </div>
              </div>
            </div>
            <div class="col-12 p-2"></div>
            <label>Vuelva a indtroducir su nueva contraseña</label>
            <div>
              <p-password
                formControlName="password2"
                [toggleMask]="true"
              ></p-password>
              <div
                *ngIf="
                  fg.get('password2').invalid &&
                  (fg.get('password2').dirty || fg.get('password2').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('password2').errors?.required">
                  <small class="p-error">No puede quedar vacío.</small>
                </div>
                <div *ngIf="fg.get('password2').errors?.minlength">
                  <small class="p-error"
                    >Debe tener una longitud mínima de 5.</small
                  >
                </div>
                <div *ngIf="fg.get('password2').errors?.maxlength">
                  <small class="p-error"
                    >Debe tener una longitud máxima de 255.</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="field col-12">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              [disabled]="!checkReadyToOpen()"
              icon="pi pi-check"
              label="Confirmar"
              pTooltip="Cambiar contraseña"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
